module.exports = "/_next/static/images/09229f81fc918947368cfae5a99cc4e7-hero-xs.png.webp";